import React, { useMemo } from 'react';
import AnimatedElement from '../components/AnimatedElement.js';

const IndustriesSection = () => (
<section
  id="industries"
  className="min-h-screen w-full flex flex-col md:flex-row items-stretch p-0 md:p-0 bg-brand-black overflow-visible lg:h-screen lg:overflow-hidden"
  
> 

<div className="w-full md:w-1/2 h-auto md:h-full flex items-center justify-center">
  <img
    src="./assets/img/h6.png"
    alt=""
    className="w-full h-auto md:h-full object-cover"
  />
</div>
  
  
  <div className="w-full md:w-1/2 h-auto md:h-full flex flex-col justify-center px-8 py-10 md:py-0">
  <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white  leading-8 text-[24px]"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}>                <p className="block justify-center text-brand-peach" style={{     direction: "rtl",
    textAlign: "justify",
    textAlignLast: "center",
    fontFamily: "pinar",
    lineHeight: "2",}}>
                    
                    Network-Driven Work

                </p>
                </AnimatedElement>
        <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white  leading-8 text-[18px]"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}>                <p className="block justify-center" style={{     direction: "rtl",
    textAlign: "justify",
    textAlignLast: "right",
    fontFamily: "pinar",
    lineHeight: "2",}}>
                    
                    مدل همکاری من مبتنی بر شبکه ای از متخصصان مستقل است.

                </p>
                </AnimatedElement>
                <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white  leading-8 text-[18px]"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}> 
  
                <p className="block justify-center" style={{     direction: "rtl",
    textAlign: "justify",
    textAlignLast: "right",
    fontFamily: "pinar",
    lineHeight: "2",}}>
                    
                    در این ساختار ، برای هر پروژه ترکیب درستی از مهارتها کنار هم قرار می گیرد  ; چابک ، دقیق و منعطف.

                    </p>

                    </AnimatedElement>
                    <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white  leading-8 text-[18px]"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}> 

                <p className="block justify-center" style={{     direction: "rtl",
    textAlign: "justify",
    textAlignLast: "right",
    fontFamily: "pinar",
    lineHeight: "2",}}>
                    
نتیجه این رویکرد پروژه هایی است که به جای وابستگی به یک فرد ، بر یک شبکه حرفه ای تکیه دارند ; جایی که کیفیت ، تخصص و خلاقیت بصورت همزمان تقویت می شود.                    
                    
                    </p>

            </AnimatedElement>
            </div>
   
</section>
);

  


export default IndustriesSection;



